import { WidgetLocale } from 'types';
import { StringCatalog } from './types';

type CatalogLoader = () => Promise<{ default: StringCatalog }>;

/**
 * Each locale's catalog is its own async chunk.  Only the chunk for the
 * requested locale is ever loaded.
 */
const catalogLoaders: Record<WidgetLocale, CatalogLoader> = {
  en: () => import(/* webpackChunkName: "strings-en" */ './catalogs/en'),
  fr: () => import(/* webpackChunkName: "strings-fr" */ './catalogs/fr'),
};

const catalogCache: Partial<Record<WidgetLocale, Promise<StringCatalog>>> = {};

/**
 * Loads the string catalog for a locale.  The in-flight promise is cached at
 * module level so every widget instance on a page shares a single load.
 */
export default function loadStringCatalog(
  locale: WidgetLocale,
): Promise<StringCatalog> {
  const cached = catalogCache[locale];

  if (cached !== undefined) {
    return cached;
  }

  const pending = catalogLoaders[locale]().then((module) => module.default);

  catalogCache[locale] = pending;

  pending.catch(() => {
    delete catalogCache[locale];
  });

  return pending;
}
